/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateTableRequest,
  CreateTableResponse,
  GetTableListResponse,
  UpdateTableRequest,
  UpdateTableResponse,
} from '../models/index';

export interface CreateDatasetTableRequest {
    datasetId: string;
    createTableRequest: CreateTableRequest;
}

export interface DeleteDatasetTableRequest {
    tableId: string;
}

export interface GetDatasetTableListRequest {
    datasetId: string;
}

export interface UpdateDatasetTableRequest {
    tableId: string;
    updateTableRequest: UpdateTableRequest;
}

/**
 * 
 */
export class DatasetTablesControllerApi extends runtime.BaseAPI {

    /**
     */
    async createDatasetTableRaw(requestParameters: CreateDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTableResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling createDatasetTable().'
            );
        }

        if (requestParameters['createTableRequest'] == null) {
            throw new runtime.RequiredError(
                'createTableRequest',
                'Required parameter "createTableRequest" was null or undefined when calling createDatasetTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bot/dataset/{datasetId}/tables`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createDatasetTable(requestParameters: CreateDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTableResponse> {
        const response = await this.createDatasetTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteDatasetTableRaw(requestParameters: DeleteDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tableId'] == null) {
            throw new runtime.RequiredError(
                'tableId',
                'Required parameter "tableId" was null or undefined when calling deleteDatasetTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bot/dataset/tables/{tableId}`.replace(`{${"tableId"}}`, encodeURIComponent(String(requestParameters['tableId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDatasetTable(requestParameters: DeleteDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDatasetTableRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDatasetTableListRaw(requestParameters: GetDatasetTableListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTableListResponse>> {
        if (requestParameters['datasetId'] == null) {
            throw new runtime.RequiredError(
                'datasetId',
                'Required parameter "datasetId" was null or undefined when calling getDatasetTableList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bot/dataset/{datasetId}/tables`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters['datasetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDatasetTableList(requestParameters: GetDatasetTableListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTableListResponse> {
        const response = await this.getDatasetTableListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDatasetTableRaw(requestParameters: UpdateDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateTableResponse>> {
        if (requestParameters['tableId'] == null) {
            throw new runtime.RequiredError(
                'tableId',
                'Required parameter "tableId" was null or undefined when calling updateDatasetTable().'
            );
        }

        if (requestParameters['updateTableRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTableRequest',
                'Required parameter "updateTableRequest" was null or undefined when calling updateDatasetTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bot/dataset/tables/{tableId}`.replace(`{${"tableId"}}`, encodeURIComponent(String(requestParameters['tableId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateDatasetTable(requestParameters: UpdateDatasetTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateTableResponse> {
        const response = await this.updateDatasetTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
